<script lang="ts">
  let className: string | undefined = undefined;
  export { className as class };
</script>

<svg
  width="1402"
  height="1139"
  viewBox="0 0 1402 1139"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={className}
>
  <path
    d="M1155.95 1043.3C1115.82 1047.1 1009.29 1019.54 949.243 996.553C800.494 946.576 470.764 720.286 306.888 292.259C288.444 236.479 289.497 153.774 283.466 58.917L442.481 457.322C443.562 494.75 514.917 503.99 561.729 578.211C721.693 788.118 878.427 897.918 1075.76 945.164C1081.03 946.426 1086.54 946.088 1091.85 944.974C1110.57 941.042 1121.53 945.946 1138.41 953.502L1139.33 953.91C1155.01 960.925 1171.41 963.092 1183.8 960.68C1185.22 960.404 1186.75 962.166 1187.11 963.565C1188.25 967.972 1186.37 971.81 1182.33 973.915L1174.1 977.491C1189.37 980.222 1203.58 980.167 1211.42 979.797C1214.38 979.658 1217.02 981.772 1217.4 984.713C1217.61 986.349 1217.51 988.048 1216.35 989.223C1213.81 991.796 1208.11 995.182 1201.88 995.306C1203.58 996.98 1202.04 1006.24 1195.06 1010.69L1192.18 1012.43C1188.95 1019.34 1183.6 1024.42 1177.03 1028.29C1175.16 1029.39 1173.81 1030.6 1173.74 1032.1C1175.31 1040.8 1161.62 1042.76 1155.95 1043.3Z"
    class="fill-foreground"
  />
  <path
    d="M1166.61 1048.89C1126.49 1052.7 1019.95 1025.13 959.905 1002.15C811.155 952.173 472.686 745.212 308.81 317.185C290.366 261.405 251.971 126.13 245.94 31.273L355.161 59.8595C380.743 275.832 471.148 435.854 517.961 510.074C665.147 765.232 899.338 918.504 1087.47 951.474C1092.12 952.289 1096.83 951.827 1101.45 950.834C1121.07 946.609 1131.8 952.712 1149.99 959.507C1165.79 965.41 1182.07 968.689 1194.46 966.277C1195.88 966.001 1197.41 967.763 1197.77 969.162C1198.91 973.569 1197.03 977.407 1193 979.512L1184.77 983.088C1200.03 985.819 1214.24 985.764 1222.08 985.394C1225.04 985.254 1227.68 987.369 1228.06 990.31C1228.27 991.946 1228.17 993.645 1227.01 994.82C1224.48 997.393 1218.77 1000.78 1212.55 1000.9C1214.25 1002.58 1212.7 1011.84 1205.72 1016.29L1202.84 1018.03C1199.61 1024.94 1194.26 1030.02 1187.69 1033.89C1185.82 1034.99 1184.47 1036.2 1184.4 1037.69C1185.98 1046.4 1172.29 1048.36 1166.61 1048.89Z"
    fill="url(#paint0_linear_136_784)"
  />
  <path
    d="M1184.56 1038.38C1178.73 1040.84 1164.19 1037.48 1157.98 1034.51C1168.38 1038.29 1179.24 1036.19 1183.37 1034.66C1184.36 1035.89 1184.52 1036.58 1184.56 1038.38Z"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="fill-foreground"
  />
  <path
    d="M1184.4 1037.69C1185.98 1046.4 1167.57 1048.32 1161.89 1048.86C1121.77 1052.66 1019.95 1025.13 959.905 1002.15C811.155 952.173 472.686 745.212 308.81 317.185C290.366 261.405 251.971 126.13 245.94 31.273L355.161 59.8595C380.743 275.832 471.148 435.854 517.961 510.074C665.147 765.232 899.338 918.504 1087.47 951.474C1092.12 952.289 1096.83 951.826 1101.45 950.837C1121.06 946.632 1131.76 952.827 1149.99 959.507C1165.37 965.142 1182.07 968.689 1194.46 966.277C1195.88 966.001 1197.41 967.763 1197.77 969.162C1198.91 973.569 1195.36 979.478 1184.77 983.088M1158 1034.53C1169.5 1037.4 1177.72 1036.52 1188.01 1033.29C1195.17 1031.04 1200.54 1025.17 1202.84 1018.03V1018.03M1162.62 1017.91C1180.03 1021.28 1196.95 1021.88 1205.72 1016.29C1212.7 1011.84 1214.25 1002.58 1212.55 1000.9M1166.64 998.543C1192.88 999.618 1213.88 1005.09 1225.36 996.501C1227.61 994.821 1228.33 991.892 1227.97 989.111V989.111C1227.73 987.223 1226.04 985.856 1224.13 985.929C1216.83 986.209 1201.37 986.058 1184.77 983.088M1184.77 983.088C1180.27 982.704 1169.66 981.5 1163.18 979.753"
    stroke="url(#paint1_linear_136_784)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M1049.68 1023.11C1044.64 1031.03 1034.14 1033.37 1026.21 1028.33C1018.29 1023.29 1015.96 1012.78 1020.99 1004.86C1026.03 996.939 1036.54 994.602 1044.46 999.641C1052.38 1004.68 1054.72 1015.19 1049.68 1023.11Z"
    fill="currentColor"
  />
  <path
    d="M1020.99 1004.86C1015.96 1012.78 1018.29 1023.29 1026.21 1028.33C1034.14 1033.37 1044.64 1031.03 1049.68 1023.11C1054.72 1015.19 1052.38 1004.68 1044.46 999.641M1020.99 1004.86C1026.03 996.939 1036.54 994.602 1044.46 999.641M1020.99 1004.86C1018.32 978.508 1030.15 951.031 1036.4 940.586M1044.46 999.641C1040.96 976.08 1052.4 953.928 1058.56 945.797"
    stroke="currentStroke"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M1021.11 1003.75C1026.54 992.98 1038.38 991.819 1043.62 992.585L1044.46 999.641C1034.55 992.863 1024.76 999.556 1021.11 1003.75Z"
    stroke="currentStroke"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="fill-foreground"
  />
  <defs>
    <linearGradient
      id="paint0_linear_136_784"
      x1="1075.5"
      y1="991"
      x2="165"
      y2="36.9999"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.764819" stop-color="currentColor" />
      <stop offset="0.893466" stop-color="currentColor" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_136_784"
      x1="841.5"
      y1="891.5"
      x2="321"
      y2="224"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.875134" style="stop-color: hsl(var(--color-foreground));" />
      <stop offset="1" stop-color="currentColor" />
    </linearGradient>
  </defs>
</svg>
